moduleSlider = angular.module('form.initializer', [])

moduleSlider.service 'FrameForm', ["$timeout", "$injector", "ns", ($timeout, $injector, ns) ->
  'use strict'
  Y = undefined

  form =
    init: (y) ->
      Y = y
      return
    updateQueryStringParameter: (uri, key, value) ->
      re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i')
      separator = if uri.indexOf('?') != -1 then '&' else '?'
      if uri.match(re)
        uri.replace re, '$1' + key + '=' + value + '$2'
      else
        uri + separator + key + '=' + value
    productChoosed: (products) ->
      selectedArray = []
      for category in products
        for group, index in category.goods
          selectedArray.push group if group.selected
      selectedArray.length > 0
    setSelectedFirstProduct: (products) ->
      for category in products
        for group, index in category.goods
          if index is 0
            group.selected = true
            return false
    getPath: (href) ->
      l = document.createElement("a")
      l.href = href
      href.replace(l.origin, "")
    getProductsString: (products) ->
      productsArr = []
      for category in products
        for product in category.goods
          if product.selected
            productsArr.push product.name
      productsString = productsArr.join(":")
      productsString
    updateFrameForms: (layout = Y) ->
      parent = @
      $timeout.cancel @updateTimeout if @updateTimeout
      @updateTimeout = $timeout ->
        layout.all(".frame-form").each (frameFormWrapper) ->
          frame = $(frameFormWrapper._node).find("iframe")
          newUrl = frameFormWrapper.ancestor(".str-bw_form").widget.frame_settings.frame_url
          productChoosed = parent.productChoosed frameFormWrapper.ancestor(".str-bw_form").widget.frame_settings.products
          if !productChoosed
            frameFormWrapper.ancestor(".str-bw_form").widget.frame_settings.products = angular.copy window.justclick.groups
            parent.setSelectedFirstProduct frameFormWrapper.ancestor(".str-bw_form").widget.frame_settings.products
            products = parent.getProductsString frameFormWrapper.ancestor(".str-bw_form").widget.frame_settings.products
            newUrl = parent.updateQueryStringParameter newUrl, "goods", products
            newUrl = parent.getPath newUrl
          frameWidth = frame.width()
          newUrl = parent.updateQueryStringParameter newUrl, "width", frameWidth-70
          newUrl = parent.updateQueryStringParameter newUrl, "btn_width", frameWidth-70
          frameFormWrapper.ancestor(".str-bw_form").widget.frame_settings.frame_url = newUrl
          frame.attr "src", newUrl
          frame.unbind "load"
          frame.on "load", ->
            frameFormWrapper.ancestor(".str-bw_form").widget.frame_settings.frame_height = frame[0].contentWindow.document.body.offsetHeight
            frame.parents(".frame-form").css "height", frameFormWrapper.ancestor(".str-bw_form").widget.frame_settings.frame_height
      , 500
      return
    destroy: ->
      return
  form

]



// WEBPACK FOOTER //
// ./src/app/editor/widget_initializers/form/form.initializer.coffee